import { API_ROUTES } from '@config/routes';
import type { ClientAggregate } from '@/types';
import api from './api';

export const clientService = {
  getClients: (): Promise<ClientAggregate[]> => api.get<ClientAggregate[]>(API_ROUTES.CLIENTS.BASE),
  syncClients: (): Promise<ClientAggregate[]> =>
    api.post<ClientAggregate[]>(API_ROUTES.CLIENTS.SYNC),
  mergeClients: (primaryClientId: string, secondaryClientId: string): Promise<ClientAggregate> =>
    api.post<ClientAggregate>(API_ROUTES.CLIENTS.MERGE, { primaryClientId, secondaryClientId }),
  splitClientContact: (clientId: string, contactId: string): Promise<ClientAggregate> =>
    api.post<ClientAggregate>(API_ROUTES.CLIENTS.SPLIT_CONTACT(clientId), { contactId }),
};
